import React from 'react';
import { Receipt } from 'lucide-react';
import type { MockInvoiceSummary } from '@/types/purchaseFlow';

interface InvoiceSummaryBlockProps {
  data: unknown;
}

const InvoiceSummaryBlock: React.FC<InvoiceSummaryBlockProps> = ({ data }) => {
  const inv = data as MockInvoiceSummary;
  if (!inv?.invoice_number) return null;

  return (
    <div className="mt-2 rounded-lg border border-blue-200 dark:border-blue-800 bg-blue-50 dark:bg-blue-900/20 p-3 text-xs">
      <div className="flex items-center gap-2 mb-2">
        <Receipt className="w-4 h-4 text-blue-600" />
        <span className="font-semibold text-blue-800 dark:text-blue-300">Invoice {inv.invoice_number}</span>
        <span className={`ml-auto px-1.5 py-0.5 rounded text-[10px] font-medium ${
          inv.status === 'paid' ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400' :
          inv.status === 'draft' ? 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400' :
          'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400'
        }`}>
          {inv.status}
        </span>
      </div>

      <div className="space-y-1 text-gray-600 dark:text-gray-400">
        <div className="flex justify-between">
          <span className="text-gray-500">Vendor</span>
          <span>{inv.vendor_name}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500">Date</span>
          <span>{inv.invoice_date}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500">Due</span>
          <span>{inv.due_date}</span>
        </div>

        <div className="border-t border-blue-200 dark:border-blue-800 pt-1.5 mt-1.5">
          {inv.items.map((item, i) => (
            <div key={i} className="flex justify-between">
              <span className="truncate mr-2">{item.product_name} ×{item.quantity}</span>
              <span className="font-mono whitespace-nowrap">{inv.currency} {item.amount.toLocaleString()}</span>
            </div>
          ))}
        </div>

        <div className="border-t border-blue-200 dark:border-blue-800 pt-1.5 flex justify-between font-semibold text-gray-800 dark:text-gray-200">
          <span>Total</span>
          <span className="font-mono">{inv.currency} {inv.grand_total.toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
};

export default InvoiceSummaryBlock;
